module.exports = __webpack_public_path__ + "img/bl.323a05b6.svg";